import { LuxButton, Color } from '@lux/wardrobe-lib'
import './TypeList.scss'

export interface Type {
    key: string
    icon: string
    active?: boolean
    label: string
}

export interface TypeListProps {
    onClick: (key: string, active: boolean) => void
    typeList: Type[]
    isEdit?: boolean
    title: string
}

const TypeList = ({ onClick, typeList, isEdit, title: title }: TypeListProps) => {
    const componentClass = 'smart-modals-type-list'

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title`}>{title}</div>
            <div className={`${componentClass}__choose-container`}>
                {typeList.map((type: Type) => (
                    <LuxButton
                        key={type.key}
                        text={type.label}
                        iconLeft={type.icon}
                        iconRight={type.active ? 'status-ok' : null}
                        isTag={true}
                        color={type.active ? Color.BLUE : Color.BG_GREY}
                        style={{
                            backgroundColor: type.active
                                ? 'var(--lux-primary)'
                                : 'var(--lux-bg-grey)',
                            color: type.active ? 'var(--lux-white)' : 'var(--lux-black)',
                        }}
                        onClick={onClick.bind(null, type.key, type.active)}
                        disabled={isEdit}
                    />
                ))}
            </div>
        </div>
    )
}

export default TypeList
